import useSWR from 'swr';
import app from '../base';

const useSummary = (start, end) => {
  const { data, error, mutate } = useSWR([
    `/reports/users/summary?start=${start}&end=${end || start}`,
    undefined,
    app.auth().currentUser.uid
  ]);

  return {
    summary: data,
    isLoading: !error && !data,
    isError: error,
    mutateSummary: mutate
  };
};

export default useSummary;
